import React from 'react';
import { Table, Spinner } from 'reactstrap';

function DependentInfo({ data, isLoading }) {
  const employeeData = data ?? {};

  const renderTableBody = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={5}>
            <div className="d-flex flex-row justify-content-center align-items-center gap-1">
              <Spinner color="dark" size="sm" />
              <span className="ms-2">Loading...</span>
            </div>
          </td>
        </tr>
      );
    }
    return Array.isArray(employeeData) ? (
      employeeData.map((dependent, index) => (
        <tr key={dependent?.Name}>
          <td style={{ width: '20px' }}>{index + 1}</td>
          <td>{dependent?.Name}</td>
          <td>{dependent?.Relation}</td>
          <td>{dependent?.DateofBirth}</td>
          <td>{dependent?.TicketEligibility}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="5" className="text-center">
          No dependents found.
        </td>
      </tr>
    );
  };

  return (
    <div className="p-0">
      <Table
        hover
        className="custom-table align-middle text-nowrap"
        id="dependent-profile-table"
      >
        <thead>
          <tr>
            <th className="fw-semibold">#</th>
            <th className="fw-semibold">Dependent</th>
            <th className="fw-semibold">Relation</th>
            <th className="fw-semibold">Date of Birth</th>
            <th className="fw-semibold">Ticket Eligibility</th>
          </tr>
        </thead>
        <tbody>{renderTableBody()}</tbody>
      </Table>
    </div>
  );
}

export default DependentInfo;
